import React from 'react';
import { Link } from 'react-router-dom';
import Head from '../../components/Head';
import './legal.css';

const Tos = () => {
  return (
    <div className="legal-page">
      <Head title="Terms of Service" />

      <div className="legal-header">
        <Link to="/" className="legal-back">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></svg>
          Back to home
        </Link>
        <h1>Terms of Service</h1>
        <p>Last updated: March 5, 2026</p>
      </div>

      <div className="legal-body">
        <h2>Service Description</h2>
        <p>
          TextLink LTD offers an advanced SMS API Service enabling users to send SMS messages through our API seamlessly.
        </p>

        <h2>Payment Terms</h2>
        <p>
          Enjoy the first two messages on us, completely free of charge. Subsequently, our service operates on a pay-as-you-go basis, requiring users to purchase bulk SMS packages for continued usage.
        </p>

        <h2>Refund Policy</h2>
        <p>
          We stand by our service's reliability and user satisfaction. Should you find yourself unsatisfied with our service, we offer refunds for unused messages within your purchased packages, provided no violation of our terms has occurred. Refund requests must be submitted within 7 days from the date of purchase.
        </p>
        <p>
          Should your needs change, we also offer the flexibility to swap your current subscription, package, or credits for another service of equivalent value within 7 days of purchase. For assistance, please reach out to <a href="mailto:aaronb@textlinksms.com">aaronb@textlinksms.com</a>.
        </p>

        <h2>Use of Service</h2>
        <p>
          The TextLink LTD SMS API Service may only be used for lawful purposes and in accordance with the terms of this agreement. Prohibited uses include, but are not limited to, sending spam or other unsolicited messages, sending illegal or harmful content, or using the service to harass or abuse others. Users may only send promotional messages to recipients who have given their explicit consent.
        </p>

        <h2>TCPA Compliance and User Certification</h2>
        <p>
          By using the TextLink LTD SMS API Service, Users certify that they have obtained "prior express written consent" as defined by the Telephone Consumer Protection Act (TCPA) for every recipient before sending any message. Users acknowledge and agree that TextLink LTD is a passive conduit for transmission only and does not provide, verify, or vet contact lists. Users bear sole responsibility for ensuring all messages are sent in full compliance with the TCPA, Cellular Telecommunications Industry Association (CTIA) guidelines, and all applicable Application-to-Person (A2P) messaging regulations.
        </p>

        <h2>Indemnification</h2>
        <p>
          User agrees to indemnify, defend, and hold harmless TextLink LTD, its officers, directors, employees, agents, and its distribution partners (including, but not limited to, AppSumo and affiliated resellers) from and against any and all claims, demands, damages, losses, liabilities, costs, and expenses (including reasonable attorneys' fees) arising out of or related to: (a) User's failure to comply with the TCPA, CTIA guidelines, A2P regulations, or any other applicable laws or regulations; (b) User's breach of these Terms of Service; (c) User's use or misuse of the TextLink LTD SMS API Service; or (d) any message content transmitted by User through the Service.
        </p>

        <h2>Prohibited Uses</h2>
        <p>The following activities are strictly prohibited and will result in immediate account termination without refund:</p>
        <ul>
          <li>Sending "cold" marketing messages to recipients who have not provided prior express written consent</li>
          <li>Use of purchased, rented, or third-party lead lists</li>
          <li>Automated harassment, threats, or abusive messaging</li>
          <li>Any messaging that violates the TCPA, CTIA guidelines, or A2P regulations</li>
          <li>Phishing, fraud, or deceptive messaging practices</li>
          <li>Sending messages with illegal, harmful, or objectionable content</li>
        </ul>
        <p>TextLink LTD reserves the right to determine, in its sole discretion, whether any use constitutes a violation of this section.</p>

        <h2>Lifetime Deal Device Restrictions</h2>
        <p>
          Users who have purchased or redeemed a lifetime deal (including, but not limited to, deals offered through AppSumo or affiliated resellers) are expressly prohibited from using devices and SIM cards that were previously registered, configured, or used under a separate active or expired subscription plan. Each subscription and lifetime deal entitlement is independent; devices and SIM cards are non-transferable between them. Violation of this restriction may result in immediate account suspension or termination without refund.
        </p>

        <h2>Limitation of Liability</h2>
        <p>
          We shall not be liable for any damages or losses incurred as a result of the use of our TextLink LTD SMS API Service.
        </p>

        <h2>Termination of Service</h2>
        <p>
          We reserve the right to terminate the TextLink LTD SMS API Service or any user's access to the service at any time and without notice, in the event of a violation of these terms or for any other reason.
        </p>

        <h2>Changes to Terms of Service</h2>
        <p>
          We reserve the right to modify these terms at any time, and such changes will be effective immediately upon posting. Your continued use of the TextLink LTD SMS API Service constitutes your acceptance of the revised terms.
        </p>

        <h2>Governing Law</h2>
        <p>
          This agreement shall be governed by and construed in accordance with the laws of the country in which the service is provided.
        </p>

        <p>
          By using our TextLink LTD SMS API Service, you agree to be bound by these terms and conditions.
        </p>
      </div>
    </div>
  );
};

export default Tos;
